import { Group, Tabs } from "@mantine/core";
import React from "react";
import { useHistory } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import ChecklistSelector from "./ChecklistSelector";
import { setActiveChecklistTabInRedux } from "./checklistSlice";

const ChecklistTabs: React.FC<{
  activeTab: string;
}> = ({ activeTab }) => {
  const dispatch = useAppDispatch();
  const checklist = useAppSelector((state) => state.checklistReducer.checklist);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);

  const urlHasDoksamEqualsTrue = params.get("doksam") === "true";

  return (
    <Group
      justify="space-between"
      align="end"
      pt="xs"
      mx="xs"
      wrap="nowrap"
      style={{ boxShadow: "inset 0 -2px 0 0 #e4e7eb" }}
    >
      <Tabs
        value={activeTab}
        onChange={(value) => dispatch(setActiveChecklistTabInRedux((value ?? "CHECKLIST") as any))}
        styles={{ tab: { fontWeight: 600 } }}
      >
        <Tabs.List>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="CHECKLIST">
            {checklist.isTemplate === true ? "Sjekklistemal" : "Sjekkliste"}
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="LOGS">
            Logg
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="SETTINGS">
            Innstillinger
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Group gap="sm" wrap="nowrap" pb="xs">
        {urlHasDoksamEqualsTrue === false && <ChecklistSelector />}
      </Group>
    </Group>
  );
};

export default ChecklistTabs;
